/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_COSTUME_VALUES } from "../graphql";

const log: any = LoggerModule?.getInstance();

export interface GetCostumeValuesProps {
  id: string;
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetCostumeValuesMethods extends IPluginMethodMap {
  getCostumeValues(args: any): Promise<any>;
}

export class GetCostumeValuesService implements IAgentPlugin {
  readonly methods: IGetCostumeValuesMethods;

  constructor() {
    this.methods = {
      getCostumeValues: this.getCostumeValues.bind(this),
    };
  }

  async getCostumeValues(args: GetCostumeValuesProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.query({
          query: GET_COSTUME_VALUES,
          variables: {
            filter: {
              costumeAttribute: {
                eq: args,
              },
            },
            options: {
              sort: {
                field: "position",
                order: "asc",
              },
              limit: 0,
              skip: 0,
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data?.getCostumeValues) {
          return {
            ...res?.data?.getCostumeValues,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
